import styled from "@emotion/styled";
import { IconCoinbase, IconMetamask, IconWalletConnect } from "atoms";
import { Button } from "atoms/Button";
import { recordEvent } from "utils/analytics";
import type { Connector, ConnectorState } from "../types";
import { useAuth } from "./AuthProvider";

function ConnectWallet({ children }: { children?: React.ReactNode }) {
  const { user, metaMask, coinBase, walletConnect } = useAuth();

  if (user) {
    return null;
  }

  return (
    <Wrapper>
      {children}

      <Buttons>
        <ConnectButton {...metaMask} label="MetaMask" />
        <ConnectButton {...coinBase} label="CoinBase" />
        <ConnectButton {...walletConnect} label="WalletConnect" />
      </Buttons>
      {/* TODO: Add in this content page
      <Text>
        <strong>
          Don&apos;t have a wallet?{" "}
          <Link to="/how-to-create-a-wallet-page???">
            Learn how to create one.
          </Link>
        </strong>
      </Text>
      */}
    </Wrapper>
  );
}

function ConnectIcon({ label }: { label: string }) {
  if (label === "MetaMask") {
    return <IconMetamask />;
  }
  if (label === "CoinBase") {
    return <IconCoinbase />;
  }
  if (label === "WalletConnect") {
    return <IconWalletConnect />;
  }
  return null;
}

function ConnectButton({
  connector,
  state,
  label,
}: {
  connector: Connector;
  state: ConnectorState;
  label: string;
}) {
  const onClick = () => {
    connector.connect();
    recordEvent("login", { method: label });
  };

  return (
    <SButton variant="primary" onClick={onClick} disabled={state.isConnecting}>
      <ConnectIcon label={label} /> Connect {label}
    </SButton>
  );
}

const Wrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "1rem",
});
const SButton = styled(Button)(({ theme }) => ({
  ...theme.fonts.body,
  fontSize: theme.fontSizes.sm,
  fontWeight: "bold",
  alignItems: "center",
  textTransform: "none",
  gap: 10,
  "&>svg": {
    width: "1em",
    height: "auto",
  },
}));
const Buttons = styled.div(
  {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    button: {
      width: "100%",
    },
  },
  ({ theme }) => ({
    "button + button": {
      marginTop: theme.spacing.md,
    },
  })
);

export { ConnectWallet };
